// Entry screen: choose between the 2D map view and the 3D terrain view.
import { clear, h } from "./dom";
import { t } from "./i18n";

export function renderModes(root: HTMLElement): () => void {
  clear(root).append(
    h(
      "div",
      { className: "picker" },
      h("h1", {}, t("mode.heading")),
      h("p", { className: "intro" }, t("mode.intro")),
      h(
        "div",
        { className: "mode-cards" },
        h(
          "a",
          { className: "mode-card", href: "#/2d" },
          h("div", { className: "mode-icon" }, "▦"),
          h("h3", {}, t("mode.2d")),
          h("p", {}, t("mode.2d.desc")),
        ),
        h(
          "a",
          { className: "mode-card", href: "#/3d" },
          h("div", { className: "mode-icon" }, "◭"),
          h("h3", {}, t("mode.3d")),
          h("p", {}, t("mode.3d.desc")),
        ),
      ),
    ),
  );
  return () => undefined;
}
